import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { Dropdown } from '@bibliocommons/base-dropdown';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import CommentableForm from './category_forms/CommentableForm';
import SuggestForPurchaseForm from './category_forms/SuggestForPurchaseForm';

const propTypes = {
  categories: ImmutablePropTypes.listOf(PropTypes.string),
  selectedCategory: PropTypes.string,
  isSubmitting: PropTypes.bool,
  intl: intlShape,
  suggestForPurchaseEnabled: PropTypes.bool,
  actions: PropTypes.objectOf(PropTypes.func).isRequired
};

export class FeedbackForm extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleSubmit', 'handleMessageChange');
    this.state = {
      messageText: ''
    };
  }

  static getBrowserInformation() {
    return {
      screenResolution: `${window.screen.width} x ${window.screen.height}`,
      viewportSize: `${window.outerWidth} x ${window.outerHeight}`,
      referer: window.location.href,
      userAgent: window.navigator.userAgent
    };
  }

  getCategoryOptions() {
    return this.props.categories.valueSeq().map((category) => ({
      label: this.props.intl.formatMessage({ id: `feedback_cat_${category}` }),
      value: category
    }));
  }

  getSelectedCategoryLabel() {
    const localizationKey = this.props.selectedCategory || 'default';
    return this.props.intl.formatMessage({ id: `feedback_cat_${localizationKey}` });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.actions.submitFeedback({
      comment: this.state.messageText,
      ...FeedbackForm.getBrowserInformation(),
      category: this.props.selectedCategory,
      optIn: false
    });
  }

  handleMessageChange(messageText) {
    this.setState({ messageText });
  }

  renderFormFields() {
    switch (this.props.selectedCategory) {
      case null:
        return null;
      case 'suggest_for_purchase': {
        if (this.props.suggestForPurchaseEnabled) {
          return <SuggestForPurchaseForm />;
        }
        return (
          <CommentableForm
            value={this.state.messageText}
            selectedCategory={this.props.selectedCategory}
            handleMessageChange={this.handleMessageChange} />
        );
      }
      default:
        return <CommentableForm value={this.state.messageText} handleMessageChange={this.handleMessageChange} />;
    }
  }

  render() {
    return (
      <form className="cp-feedback-form" onSubmit={this.handleSubmit}>
        <div className="form-group">
          <ScreenReaderMessage id="feedback-category-label">
            <FormattedMessage id="feedback_category_label" />
          </ScreenReaderMessage>
          <Dropdown
            handleSelect={this.props.actions.updateCategory}
            labelledById="feedback-category-label"
            options={this.getCategoryOptions()}
            selected={this.getSelectedCategoryLabel()} />
        </div>
        {this.renderFormFields()}
      </form>
    );
  }
}

FeedbackForm.propTypes = propTypes;

export default injectIntl(FeedbackForm);



// WEBPACK FOOTER //
// ./app/components/feedback/FeedbackForm.jsx